import * as PIXI from "pixi.js";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { FontStyle } from "../style/FontStyle";
import { SlingoStyle } from "../style/SlingoStyle";
/**
 * AbstractSpinsRemainingProperties.ts
 */
export class AbstractSpinsRemainingProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.backgroundProperties.equals(other.backgroundProperties) &&
            this.backgroundFreeProperties.equals(other.backgroundFreeProperties) &&
            this.backgroundPurchaseProperties.equals(other.backgroundPurchaseProperties) &&
            this.standardProperties.equals(other.standardProperties) &&
            this.purchaseProperties.equals(other.purchaseProperties) &&
            (this.updateTweenProperties === other.updateTweenProperties);
    }
    setDefaultValues() {
        this.position = new PIXI.Point(0, 0);
        this.backgroundProperties = new /*SpineProperties*/ SpriteProperties(SlingoStyle.REMAINING_SPINS, SlingoStyle.MODULE, null, null, new PIXI.Point(0.5, 0.5));
        this.backgroundFreeProperties = new SpriteProperties(SlingoStyle.REMAINING_FREE_SPINS, SlingoStyle.MODULE, null, null, new PIXI.Point(0.5, 0.5));
        this.backgroundPurchaseProperties = new SpriteProperties(SlingoStyle.REMAINING_PURCHASE_SPINS, SlingoStyle.MODULE, null, null, new PIXI.Point(0.5, 0.5));
        this.standardProperties = new TextFieldProperties(FontStyle.STANDARD_SPINS_REMAINING, null, null, ControlConstants.CENTER, ControlConstants.CENTER);
        this.purchaseProperties = new TextFieldProperties(FontStyle.PURCHASE_SPINS_REMAINING, null, null, ControlConstants.CENTER, ControlConstants.CENTER);
        this.updateTweenProperties = {
            scale: 1.1,
            duration: 0.25
        };
    }
}
//# sourceMappingURL=AbstractSpinsRemainingProperties.js.map